import React from 'react';

import { IconProps } from './types';

export const CellTitleIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M10.0462 21.9375C8.3197 21.7936 6.5973 21.5228 4.875 21.125C4.4772 19.4027 4.2064 17.6803 4.0625 15.9538M15.9538 4.0625C17.6803 4.2064 19.4027 4.4772 21.125 4.875C21.5228 6.5973 21.7936 8.3197 21.9375 10.0462M4.0625 10.0462C4.2064 8.3197 4.4772 6.5973 4.875 4.875C6.5973 4.4772 8.3197 4.2064 10.0462 4.0625M21.9375 15.9538C21.7936 17.6803 21.5228 19.4027 21.125 21.125C19.4027 21.5228 17.6803 21.7936 15.9538 21.9375"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M8.9375 17.875C9.3438 11.5019 11.375 8.125 13 8.125C14.625 8.125 16.6563 11.5019 17.0625 17.875"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M16.724 15.9242C14.24 14.625 11.7601 14.625 9.2761 15.9242"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
